import React from "react";
import { navigate } from "@reach/router";

import { Block } from "baseui/block";
import { FixedFooter } from "kanopi-components/Sticky/FixedFooter";
import { Sektion } from "kanopi-components/Layout/Sektion";
import { Kontainer } from "kanopi-components/Layout/Kontainer";
import {
  ParagraphMedium,
  HeadingLarge,
  HeadingSmall,
} from "kanopi-components/typography";
import { ConfirmationCircle } from "kw/util/ConfirmationCircle";
import { WidthContainer } from "kw/util/ChatFlow/WidthContainer";
import { NavButton } from "kw/components/NavButton/NavButton";

export function PasswordResetConfirmSuccessPage() {
  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <Kontainer>
        <Block
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingLeft="scale600"
          paddingRight="scale600"
          paddingTop="scale1200"
          paddingBottom="scale1200"
        >
          <WidthContainer>
            <ConfirmationCircle />
            <HeadingSmall marginTop="scale1200" marginBottom="0">
              Choose a new password
            </HeadingSmall>
            <HeadingLarge marginTop="scale400" center>
              Your password has been updated
            </HeadingLarge>
            <ParagraphMedium center>
              Tap the button below to log in to your account.
            </ParagraphMedium>
          </WidthContainer>
        </Block>
      </Kontainer>
      <FixedFooter>
        <Sektion>
          <Block display="flex" justifyContent="center">
            <NavButton onClick={handleGoToLogin}>Go to login</NavButton>
          </Block>
        </Sektion>
      </FixedFooter>
    </>
  );
}
